import { render, staticRenderFns } from "./UsersPage.vue?vue&type=template&id=83f1d850"
import script from "./UsersPage.vue?vue&type=script&lang=js"
export * from "./UsersPage.vue?vue&type=script&lang=js"
import style0 from "./UsersPage.vue?vue&type=style&index=0&id=83f1d850&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports